import React from 'react'
import { Link } from 'react-router-dom'
import { RegisterSidebar } from './Components/RegisterSidebar'
import { ProgressIndicator } from './Components/UI/ProgressIndicator'
import { useRegister } from './Hooks/useRegister'
import { REGISTRATION_STEPS } from './Common/validation'
import logoImg from '../../assets/logo-login.png'
import logoText from '../../assets/Ai_text_logo.png'
import { RegisterHeader } from './Components/RegisterHeader'
import { ErrorAlert } from '../Login/Components/UI/ErrorAlert'
import { PersonalInfoStep } from './Components/PersonalInfoStep'
import { CredentialsStep } from './Components/CredentialsStep'

export default function RegisterPage() {
  const {
    formData,
    loading,
    errors,
    touched,
    step,
    showPassword,
    showPassword2,
    handleChange,
    handleBlur,
    nextStep,
    prevStep,
    register,
    setShowPassword,
    setShowPassword2
  } = useRegister()

  return (
    <div className="min-h-[100dvh] flex flex-col lg:flex-row bg-gray-50">
      {/* Left side - Form */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-4 sm:p-6 min-h-[100dvh] lg:min-h-0">
        <div className="w-full max-w-[20rem] sm:max-w-sm">
          <RegisterHeader logoImg={logoImg} logoText={logoText} />

          <ErrorAlert message={errors.general} />

          <ProgressIndicator currentStep={step} />

          {step === REGISTRATION_STEPS.PERSONAL_INFO ? (
            <PersonalInfoStep
              formData={formData}
              errors={errors}
              touched={touched}
              onChange={handleChange}
              onBlur={handleBlur}
              onNext={nextStep}
            />
          ) : (
            <CredentialsStep
              formData={formData}
              errors={errors}
              touched={touched}
              onChange={handleChange}
              onBlur={handleBlur}
              onSubmit={register}
              onBack={prevStep}
              loading={loading}
              showPassword={showPassword}
              showPassword2={showPassword2}
              onTogglePassword={() => setShowPassword(!showPassword)}
              onTogglePassword2={() => setShowPassword2(!showPassword2)}
            />
          )}

          <div className="text-center mt-6">
            <p className="text-sm text-gray-600">
              Already have an account?{" "}
              <Link to="/login" className="text-teal-600 hover:text-teal-500 font-medium">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>

      {/* Right side - Image */}
      <RegisterSidebar />
    </div>
  )
}